// Phase 14 — Pro Toolkit Part 2 API client (clone, client dashboard, ownership transfer).
// Mirrors /app/mobile/src/lib/pro-toolkit-api.ts exactly.
import { apiFetch } from './api';

// 2a: Clone + client dashboard
export const cloneEvent = (eventId, body) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/clone`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const listProEvents = () =>
  apiFetch('/api/v1/pro/events');

// 2b: Ownership transfer
export const createTransfer = (eventId, body) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/transfer`, {
    method: 'POST',
    body: JSON.stringify(body),
  });

export const getEventTransfer = (eventId) =>
  apiFetch(`/api/v1/events/${encodeURIComponent(eventId)}/transfer`);

export const listPendingTransfers = () =>
  apiFetch('/api/v1/transfers/pending');

export const cancelTransfer = (transferId) =>
  apiFetch(`/api/v1/transfers/${encodeURIComponent(transferId)}/cancel`, { method: 'POST' });

export const declineTransfer = (transferId, token) =>
  apiFetch(`/api/v1/transfers/${encodeURIComponent(transferId)}/decline`, {
    method: 'POST',
    body: JSON.stringify({ token: token || undefined }),
  });

export const acceptTransfer = (transferId, token) =>
  apiFetch(`/api/v1/transfers/${encodeURIComponent(transferId)}/accept`, {
    method: 'POST',
    body: JSON.stringify({ token: token || undefined }),
  });
